import { ssoEgressCDILocs } from './components/sso-cdi/sso-cdi.locs';
import { ssoEgressCertiverseLocs } from './components/sso-certiverse/sso-certiverse.component.locs';
import { ssoEgressKryterionLocs } from './components/sso-kryterion/sso-kryterion.locs';
import { ssoTestwiseEgressLocs } from './components/sso-testwise/sso-testwise.locs';
import { ssoEgressVueLocs } from './components/sso-vue/sso-vue.locs';

export const cpSSOEgressModuleLocs = {
	...ssoTestwiseEgressLocs,
	...ssoEgressCertiverseLocs,
	...ssoEgressKryterionLocs,
	...ssoEgressVueLocs,
	...ssoEgressCDILocs,
};
